import { Component } from '@angular/core';

@Component({
  selector: 'mom-carousel-empty',
  templateUrl: 'carousel-empty.component.html',
  styleUrls: ['./carousel-empty.component.scss']
})
export class CarouselEmptyComponent {}
